/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Delete_Empty_SpaceInputs */

const en_lifecycle_delete_empty_space = /** @type {(inputs: Lifecycle_Delete_Empty_SpaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has no items. Deleting it also removes its products and cannot be undone.`)
};

const de_lifecycle_delete_empty_space = /** @type {(inputs: Lifecycle_Delete_Empty_SpaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} enthält keine Vorgänge. Dabei werden auch die Produkte entfernt. Das lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "{name} has no items. Deleting it also removes its products and cannot be undone." |
*
* @param {Lifecycle_Delete_Empty_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_empty_space = /** @type {((inputs: Lifecycle_Delete_Empty_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_Empty_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_empty_space(inputs)
	return en_lifecycle_delete_empty_space(inputs)
});